import { HttpClient } from '../HttpClient';
/**
 * * Get Announcements List
 */
export const GetAnnouncements = async (isDraft, searchString, filterBy, pageNumber = 1, rowsPerPage = 10) => {
  try {
    const { data } = await HttpClient.get('api/announcements', {
      params: {
        PageNumber: pageNumber,
        RowsPerPage: rowsPerPage,
        ...(searchString ? { SearchString: searchString } : {}),
        ...(filterBy ? { FilterBy: filterBy } : {}),
        ...(isDraft ? { IsDraft: isDraft } : {}),
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
